import { Icon } from '@chakra-ui/react';

export const Chargebee = (props) => (
  <Icon viewBox="0 0 214 240" {...props}>
    <defs><style>{`.cls-1{fill:#f30;}`}</style></defs>

    <path
      className="cls-1"
      d="M77.18,117.82,231.85,80.94V.73h-80.2Z"
    />

    <path
      className="cls-1"
      d="M.54,116.41a115.52,115.52,0,0,0,3.38,27.83l73.27-26.42L3.31,91.16A117.15,117.15,0,0,0,.54,116.39Z"
    />

    <path
      className="cls-1"
      d="M27.78,41.84l49.38,76L99.93,1.88a115.43,115.43,0,0,0-72.15,40Z"
    />

    <path
      className="cls-1"
      d="M77.18,117.82l154.67,36.86v80.2h-80.2Z"
    />

    <path
      className="cls-1"
      d="M27.79,193.78l49.38-76L99.91,233.71a115.42,115.42,0,0,1-72.14-40Z"
    />
  </Icon>
);
